import { StandardStrapiFields } from '../strapi/strapi'
import ShiftType from './shift-type'
import Team from './team'
import User from './user'

export default interface ShiftSchedule extends StandardStrapiFields {
    date: string
    employee: User
    shiftType: ShiftType
    team?: Team
    plannedHours: number
    actualHours?: number
    statusEnum: ShiftScheduleStatusEnum
}

export enum ShiftScheduleStatusEnum {
    Planned = 'planned',
    Confirmed = 'confirmed',
    Completed = 'completed',
    Absent = 'absent',
}
